export default __webpack_public_path__ + "static/media/elevate-pyl-banner-1.500226a3.jpg";